
































import Vue from 'vue'
const axios = require('axios').default
export default Vue.extend({
	name: 'newsletter',
	data() {
		return {
			showpopup: false,
			email: ''
		}
	},
	mounted() {
		this.init()
	},
	methods: {
		init() {
			setTimeout(() => this.showpopupavail(), 10000)
		},
		showpopupavail() {
			if (!Vue.prototype.$cookies.get('newsletterregister')) {
				this.showpopup = true
			}
		},
		subscribe() {
			const self = this
			if (self.email === '') {
				alert('Veuillez entrer votre adresse courriel')
			} else {
				axios.post(`${process.env.VUE_APP_VED_GROUP_URL}newslettersubscribe.php`, {agentid: self.$store.state.agentid, email: self.email}).then((response: any) => {
					if (response.data.status === 'ERROR') {
						alert(response.data.msg)
					} else {
						self.showpopup = false
						Vue.prototype.$cookies.set('newsletterregister', true, {expires: '1y'})
						alert('Vous êtes maintenant inscrit à notre infolettre')
					}
				})
			}
		}
	}
})
